import {
  PayloadAction,
  createAction,
  createSelector,
  createSlice,
} from "@reduxjs/toolkit";
import { RootState } from "../store";

type IUser = {
  isViewedOnboard: boolean;
};

const initialState: IUser = {
  isViewedOnboard: false,
};

export const resetPopupState = createAction("user/resetState");

export const userSlice = createSlice({
  name: "user",
  initialState: initialState,
  reducers: {
    setIsViewedOnboard: (
      state,
      action: PayloadAction<{ isViewedOnboard: boolean }>,
    ) => {
      state.isViewedOnboard = action.payload.isViewedOnboard;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetPopupState, () => initialState);
  },
});

// Action creators are generated for each case reducer function
export const { setIsViewedOnboard } = userSlice.actions;

const selectUserState = (state: RootState) => state.user;
export const selectIsViewedOnboard = createSelector(
  selectUserState,
  (state) => state.isViewedOnboard,
);

export default userSlice.reducer;
